export default {
    isCurrentDateActive: (startDate, endDate) => {
        console.error("isCurrentDateActive");
        console.warn(startDate);
        console.warn(endDate);
    }
};